


































































































































import { Component, Emit, Model, Prop, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import CardDesignPreview from '@/components/apps/CardDesignPreview.vue';
import TemplateSubscribeButton from '@/components/apps/TemplateSubscribeButton.vue';
import Users from '@/store/modules/Users';
import { getModule } from 'vuex-module-decorators';
import { API, Storage } from 'aws-amplify';
import ValueTypes from '@/utils/ValueTypes';

@Component({
    components: { CardDesignPreview, TemplateSubscribeButton },
})
export default class MarketPlaceCard extends Vue {

    private DEFAULT_IMAGE_URL = ValueTypes.DEFAULT_IMAGE_URL;

    @Prop({
        default: () => {
            return {};
        },
        type: Object,
    })
    item!: any;

    @Prop({default:false, type:Boolean})
    isSubscribe!: boolean;
    private imageCardUrl: string = '';

    private noImageUrl = this.DEFAULT_IMAGE_URL.CARD_DEFAULT;
    // private noImageUrl = '@/assets/marketplace-preview.png';
    
    get currentUserId() {
        if (getModule(Users).currentUserProfile) {
            return getModule(Users).currentUserProfile.userId;
        } else {
            return undefined;
        }
    }

    mounted() {
        // this.getImage();
    }

    @Watch('itemDetail', { deep: true })
    onchangeItemDetail() {
        // this.getImage();
    }

    private async getImage() {
        if (this.item.templateImageCard) {
            let res = await Storage.get(this.item.templateImageCard);
            this.imageCardUrl = res.toString();
        }
    }

    private dialogShow = false;

    private openDetailDialog() {
        this.dialogShow = true;
    }

    private closeDetailDialog() {
        this.dialogShow = false;
    }

}
